import React, { Fragment, useMemo } from 'react'
import PropTypes from 'prop-types'
import { useNavigate } from 'react-router'

import { areaToUrl } from 'Utils/areaUtils'
import SvgIcon from 'Components/SvgIcon'

import { _Address, _DisplayWhenMobile, _PlaceholderTitle, _Title,
  _AddressInlineLink, _AddressInlineSpan, _LeftBlock, _BackBtn, _BackBtnContainer,
  _TopIconFavShareGroup, _FavButton, _ShareButton, _AlertBtn, _AlertSVG,
} from './style'

const BuildingTopBannerMobile
  = ({
    subBuilding,
    building,
    lastPathStack,
    favourited,
    favBuilding,
    openShareModal,
    closeModalBuilding,
    subscribed,
    isMobileApp,
  }) => {
    const navigate = useNavigate()
    const address =
    building &&
    (building.addresses_string ||
      (building.primary_address && building.primary_address.title))

    const renderedBreadCrumb = useMemo(() => {
      const breadCrumbs = building?.bread_crumb
      if(breadCrumbs && breadCrumbs.length) {
        const breadCrumbsLinkArr = []
        for(let i = breadCrumbs.length; i > 0; i -= 1) {
          const bc = breadCrumbs[i - 1]
          const Elem = bc.url ? _AddressInlineLink : _AddressInlineSpan

          if(!isMobileApp || (isMobileApp && i === 1)) {
            breadCrumbsLinkArr.push(
              <Fragment key={bc.id}>
                <Elem
                  to={areaToUrl({ url: bc.url }, 'Sale')}
                  breadcrumblevel={i}
                  disableInApp
                >
                  {bc.display_name}
                </Elem>
                {i > 1 ? <span>,&nbsp;</span> : ''}
              </Fragment>,
            )
          }
        }
        return breadCrumbsLinkArr
      }
      return null
    }, [building?.id])

    return (
      <_DisplayWhenMobile>
        {
          (closeModalBuilding || (lastPathStack?.length > 1 && isMobileApp)) &&
          <_BackBtnContainer>
            <_BackBtn
              onClick={
                closeModalBuilding ||
                (lastPathStack?.length > 1 ? () => navigate(-1) : null)
              }
            >
              <SvgIcon name="#icon-arrow-final" width={10} height={23} />
            </_BackBtn>
          </_BackBtnContainer>
        }
        <_LeftBlock>
          {!address ? <_PlaceholderTitle /> : <_Title>{address}</_Title>}
          <_Address>
            <h2>
              {
                building && building.bread_crumb ?
                  <span>{renderedBreadCrumb}</span>
                  : ''
              }
            </h2>
          </_Address>
        </_LeftBlock>

        <_TopIconFavShareGroup>
          <_AlertBtn
            secondary
            medium
            onClick={() => subBuilding('Top Banner')}
            active={subscribed}
          >
            <_AlertSVG
              name="#icon-alert"
              width={16}
              height={16}
            />
            <span>
              {subscribed ? 'Disable Alerts' : 'Get Alerts'}
              {/* {isSubscribing ? <_Spinner /> : ''} */}
            </span>
          </_AlertBtn>
          <_FavButton
            secondary
            small
            aria-label="favourite"
            active={favourited}
            onClick={favBuilding}
          >
            <SvgIcon name={'#icon-favourite'} width={14} height={16} />
            <span>Favourite</span>
          </_FavButton>
          <_ShareButton
            secondary
            small
            aria-label="share"
            onClick={openShareModal}
          >
            <SvgIcon name={'#icon-share-final'} width={14} height={16} />
            <span>Share</span>
          </_ShareButton>

        </_TopIconFavShareGroup>
      </_DisplayWhenMobile>
    )
  }

BuildingTopBannerMobile.propTypes = {
  building: PropTypes.shape({
    name: PropTypes.string,
    id: PropTypes.number,
    bread_crumb: PropTypes.shape({}),
    addresses_string: PropTypes.string,
    primary_address: PropTypes.shape({
      title: PropTypes.string,
    }),
  }),
  lastPathStack: PropTypes.arrayOf(PropTypes.string),

  favourited: PropTypes.bool,
  favBuilding: PropTypes.func,
  openShareModal: PropTypes.func,
  closeModalBuilding: PropTypes.func,
  isMobileApp: PropTypes.bool,
  subscribed: PropTypes.bool,
  subBuilding: PropTypes.func,
}
export default BuildingTopBannerMobile
